export default "__VITE_ASSET__BA8V_2G5__"